import { render, staticRenderFns } from "./goldBarcode.vue?vue&type=template&id=3270ebca&"
import script from "./goldBarcode.vue?vue&type=script&lang=js&"
export * from "./goldBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports